import { ReactNode } from 'react'

import { Badge, Box, CollapsableCard, Text, useToggle } from '@factorialco/deprecated-design-system'

import { formattedAmount } from 'modules/banking/lib/paymentHelpers'

export const ExpensableCard = ({
  children,
  title,
  amountCents,
  hideDetail,
  currency,
  locale,
  total,
}: {
  children: ReactNode
  title: string
  amountCents: number
  currency: string
  hideDetail: boolean
  locale: string
  total: number
}) => {
  const [isOpen, toggle] = useToggle(false)
  if (total === 0) return null
  if (total === 1 && !hideDetail) return children
  return (
    <CollapsableCard
      open={isOpen}
      Card={
        <Box flexDirection="row" alignItems="center" justifyContent="spaceBetween">
          <Box
            flexDirection="row"
            gap="s8"
            alignItems="center"
            width="full"
            onClick={hideDetail ? undefined : toggle(!isOpen)}
          >
            <Badge>{total}</Badge>
            <Text.Normal color="textPrimary" weight="semibold">
              {title}
            </Text.Normal>
          </Box>
          <Text.Normal>
            {formattedAmount({
              amountCents,
              currency,
              locale,
            })}
          </Text.Normal>
        </Box>
      }
      Content={children}
    />
  )
}
